import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { TfiKey } from 'react-icons/tfi';
import { useSignMessage } from 'wagmi';
import { useHistory } from 'react-router-dom';
import s from './style.css';
import { Button } from '../../components';
import { auth } from '../../actions';
import { colors } from '../../foundations';
import { globalData } from '../../actions/globalVariables';
import { createPasswordHash } from '../../utils';
const WalletPasswordForm = (props) => {
    const { data, signMessage } = useSignMessage();
    const history = useHistory();
    const regeneratePassword = () => {
        const secret = globalData.accountSecret.slice(0, 44);
        signMessage({ message: secret });
    };
    useEffect(() => {
        if (data) {
            hashSignedSecret(data);
        }
    }, [data]);
    const hashSignedSecret = async (signedSecret) => {
        const salt = globalData.accountSecret.slice(44, 88);
        const password = await createPasswordHash(signedSecret, salt);
        props.login(password, () => {
            history.push('/vault/files/');
        });
    };
    return (React.createElement("div", { className: s.formContainer },
        React.createElement("div", { className: s.keyCircle },
            React.createElement(TfiKey, { size: 60, color: colors.primary })),
        React.createElement("p", { className: s.description, style: { fontSize: '18px' } }, "Regenerate password from your wallet to login."),
        React.createElement(Button, { text: 'Sign & Generate password', id: 'continue', style: { marginTop: '32px' }, onClick: regeneratePassword })));
};
const connector = connect(null, { ...auth });
export default connector(WalletPasswordForm);
